import { Calendar, GraduationCap, MapPin } from 'lucide-react';
import React from 'react';
import { messageCardUtil } from './MatchBody';
import { MatchMessageCardflagLabel } from './utils/matchMessageCardflagLabel';

interface CourseMessageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  content: any;
}

const CourseMessageCard = ({ content }: CourseMessageCardProps) => {
  const options: any = {};
  options.pills = [];
  options.subHeader;

  const duration = content.duration ?? '';
  const attendanceTypes =
    content.attendanceTypes && content.attendanceTypes.length > 0 ? content.attendanceTypes : null;

  const qualification =
    content.qualifications && content.qualifications.length > 0 ? content.qualifications?.join(', ') : null;

  const info = MatchMessageCardflagLabel(qualification, <GraduationCap />);

  if (qualification) {
    options.subHeader = info;
  }

  if (duration !== '') {
    options.pills.push({
      icon: <Calendar />,
      text: duration
    });
  }

  if (attendanceTypes !== null) {
    for (const type of attendanceTypes) {
      options.pills.push({
        icon: <MapPin />,
        text: type
      });
    }
  }

  options.entityColor = 'info-400';
  options.entityName = 'course';

  return messageCardUtil({ content, options });
};

export default CourseMessageCard;
